import { useGetAllDocumentsQuery, useGetDocumentTypesQuery } from "@api/documentManagement";
import { Button, Upload } from "antd";
import React, { useCallback } from "react";
import UploadIcon from "../../../profile/assets/images/upload.svg";
import UploadAcceptedIcon from "../../../profile/assets/images/uploadAccepted.svg";

import { DefaultLoader as Loading } from "@pages/casino/components";
import CommonLoading from "../../../../components/loading/index.jsx";
import NoContent from "../history-v2/components/NoContent";
import {
	DocDescription,
	DocName,
	DocNameWrapper,
	DocStatus,
	DocumentsContainer,
	UploadBtnWrapper,
	UploadDocWrapper,
} from "./elements";
import { useDocumentUpload } from "./hooks/useDocumentUpload";

const Documents = ({ translate }) => {
	const { data: allDocs, isLoading: documentsLoading } = useGetAllDocumentsQuery();
	const { data: docTypes } = useGetDocumentTypesQuery();
	const { handleBeforeUpload, customUpload, isDocumentUploading } = useDocumentUpload(translate);

	const getStatusClass = useCallback((status) => {
		if (!status) return "";
		switch (status) {
			case "DocumentWaiting":
				return "waiting";
			case "Pending":
				return "pending";
			case "Accepted":
				return "accepted";
			case "Rejected":
				return "rejected";
			default:
				return "";
		}
	}, []);

	const renderUploadButton = useCallback(
		(item) => {
			if (!item) return null;
			if (item.status === "Rejected" || item.status === "DocumentWaiting") {
				const isUploading = isDocumentUploading(item.documentName);
				return (
					<UploadBtnWrapper>
						<Upload
							beforeUpload={handleBeforeUpload}
							customRequest={(e) => {
								customUpload({ file: e.file, record: item });
							}}
							showUploadList={false}
							disabled={isUploading}>
							<Button
								type="default"
								loading={isUploading}
								disabled={isUploading}>
								<img
									src={UploadIcon}
									alt="Upload"
								/>
								{translate("UPLOAD")}
							</Button>
						</Upload>
					</UploadBtnWrapper>
				);
			}
			return null;
		},
		[customUpload, translate, handleBeforeUpload, isDocumentUploading]
	);

	const renderAcceptedIcon = useCallback((item) => {
		if (!item) return null;
		if (item.status === "Accepted") {
			return (
				<img
					src={UploadAcceptedIcon}
					alt="Upload Accepted"
				/>
			);
		}
		return null;
	}, []);

	const documents = allDocs?.documents || [];

	return (
		<div className="profile-page-wrapper">
			<div className="profile-page-content">
				<DocumentsContainer className="cube-form-wrapper doc-padding">
					{documentsLoading ? (
						window.HAS_MARS_LOADING ? (
							<CommonLoading loading={documentsLoading} />
						) : (
							<Loading loading={documentsLoading} />
						)
					) : documents.length > 0 ? (
						documents.map((item, index) => {
							if (!item) return null;
							const docGroupName =
								docTypes?.documentGroups?.length > 0
									? docTypes.documentGroups.find(
											(x) => x.documentName === item.documentName
										)
									: null;
							const docName = docGroupName?.documentGroupName || item.documentName;
							const docDescription = docGroupName?.description || "";
							return (
								<UploadDocWrapper
									className="upload-doc-wrapper"
									key={`doc-${index}`}>
									<DocNameWrapper>
										<DocName>
											{docName
												? docName.indexOf("_") > -1
													? docName.split("_")[0]
													: docName
												: ""}
										</DocName>
										{item?.status === "Rejected" ? (
											<DocStatus
												className={`doc-status ${getStatusClass(
													item.status
												)} rejected`}>
												{translate(item.status.toUpperCase())}!
												<span className="upload-again-text">
													{translate("UPLOAD_AGAIN")}
												</span>
											</DocStatus>
										) : (
											<DocStatus
												className={`doc-status ${getStatusClass(
													item.status
												)}`}>
												{translate(item.status.toUpperCase())}
											</DocStatus>
										)}
										{docDescription && (
											<DocDescription>{docDescription}</DocDescription>
										)}
									</DocNameWrapper>
									{renderUploadButton(item)}
									{renderAcceptedIcon(item)}
								</UploadDocWrapper>
							);
						})
					) : (
						<NoContent
							translate={translate}
							title={"NoInfoText"}
							description={"NoInfoDocument"}
						/>
					)}
				</DocumentsContainer>
			</div>
		</div>
	);
};

export default Documents;
